import { render } from "./competition.vue?vue&type=template&id=65f876f2&scoped=true"
import script from "./competition.vue?vue&type=script&lang=js"
export * from "./competition.vue?vue&type=script&lang=js"

import "./competition.vue?vue&type=style&index=0&id=65f876f2&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f876f2"]])

export default __exports__